'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = require('preact-fela');

var button = function button(_ref) {
  var color = _ref.color,
      background = _ref.background,
      dense = _ref.dense,
      padding = _ref.padding;
  return {
    color: color || '#ffffff',
    cursor: 'pointer',
    margin: '0',
    border: '0',
    display: 'inline-flex',
    padding: padding || (dense ? '4px 14px' : '10px 16px'),
    outline: 'none',
    position: 'relative',
    userSelect: 'none',
    alignItems: 'center',
    borderRadius: '2px',
    verticalAlign: 'middle',
    justifyContent: 'center',
    MozAppearance: 'none',
    textDecoration: 'none',
    backgroundColor: background || 'transparent',
    WebkitAppearance: 'none',
    WebkitTapHighlightColor: 'transparent',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '10px',
    fontWeight: 'normal',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    ':hover': {
      textDecoration: 'none',
      color: color
    },
    ':focus': {
      outline: 'none',
      textDecoration: 'none'
    }
  };
};

exports.default = (0, _preactFela.createComponentWithProxy)(button, 'button');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Button.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38